// extracted by mini-css-extract-plugin
module.exports = {"deleteModalTextBold":"bFyVtvaV"};